(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["locations-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {

  const cards = document.querySelectorAll(".location-card");

  cards.forEach(card => {

    card.addEventListener("click", function() {

      const popupId = this.dataset.popupId;
      const popup = document.getElementById(popupId);

      if (popup) {
        popup.classList.add("active");
        document.body.style.overflow = "hidden";
      }

    });

  });


  document.querySelectorAll(".location-popup").forEach(popup => {

    const closeButton = popup.querySelector(".location-popup-close");
    const backdrop = popup.querySelector(".location-popup-backdrop");


    function closePopup() {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    }


    closeButton.addEventListener("click", closePopup);

    backdrop.addEventListener("click", closePopup);

  });


  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      document.querySelectorAll(".location-popup.active")
        .forEach(popup => {
          popup.classList.remove("active");
          document.body.style.overflow = "";
        });
    }
  });

});

  } catch(e) { console.error(e); }
})();
})();
